import { ROUTES } from '@/lib/constants/routes';
import { startViewAsTab } from './session';

/**
 * Turn this tab into a view-as tab when it was opened at `/view-as#<token>`
 * (MYN-335, §51). Runs once, synchronously, before the app renders, so no
 * request can go out with the admin's own token first. The token is moved to
 * per-tab storage and the fragment is removed from the address bar and history.
 *
 * @returns true when the tab now carries a view-as session
 */
export function consumeViewAsFragment(
  location: Pick<Location, 'pathname' | 'hash'>,
  history: Pick<History, 'replaceState'>,
): boolean {
  if (location.pathname !== ROUTES.VIEW_AS || location.hash.length < 2) return false;
  if (!startViewAsTab(location.hash.slice(1))) {
    // No per-tab storage: refuse rather than run on the admin's own session.
    history.replaceState(null, '', ROUTES.VIEW_AS);
    return false;
  }
  history.replaceState(null, '', ROUTES.DASHBOARD);
  return true;
}
